import { TextInput } from "@mantine/core";
import { useForm, schemaResolver } from "@mantine/form";
import { z } from "zod";

import styles from "./user-provider-setup-wrapper.module.scss";

type UserFormProps = {
  formId: string;
  onSubmit: (formData: any) => Promise<void>;
};

export type UserFormValues = {
  firstName: string;
  lastName: string;
  jobTitle: string;
};

const schema = z.object({
  firstName: z.string().min(1, { message: "First name is required" }),
  lastName: z.string().min(1, { message: "Last name is required" }),
  jobTitle: z.string().min(1, { message: "Job title is required" }),
});

function UserForm({ formId, onSubmit }: UserFormProps) {
  const form = useForm<UserFormValues>({
    mode: "uncontrolled",
    initialValues: {
      firstName: "",
      lastName: "",
      jobTitle: "",
    },
    validate: schemaResolver(schema, { sync: true }),
  });

  return (
    <form
      id={formId}
      onSubmit={form.onSubmit((values) => onSubmit(values))}
      className={styles.form}
    >
      <TextInput label="First Name" {...form.getInputProps("firstName")} />
      <TextInput label="Last Name" {...form.getInputProps("lastName")} />
      <TextInput label="Job Title" {...form.getInputProps("jobTitle")} />
    </form>
  );
}

export default UserForm;
